 /**
 * Created by Shiv Roy on 21/11/17.
 */
import { showFormatedDate, showFormattedTime, base64Encode, showFormatedDateandTime } from '../../../../actions/utilAction';
import classNames from 'classnames';
import { renderCustomRadioButtons, renderTextArea, renderTextField, renderTimePicker } from '../../../../components/reduxFields';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
// import PatientInfo from '../../patient_info';
import React from 'react';
import history from '../../../../history';
import moment from 'moment';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from 'material-ui/Table';

import { getPatientSingleEncounters } from '../../actions/PatientActions';

class EncounterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apptid: props.match.params.apptid,
      encid: props.match.params.id,
      patientId: null,
      appointmentTypeName: '',
      appointmentDate: null,
      appointmentTime: null,
      staffName: '',
      serviceFacility: '',
      isDirectService: false,
      PatientLocationName: '',
      renderingProviderName: '',
      EmployeeSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      RenderingProviderSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      IsRBTPresent: null,
    };
    this.handleBackClick = this.handleBackClick.bind(this);
    this.changeIsRBTPresent = this.changeIsRBTPresent.bind(this);
  }

  componentWillMount() {
    let searchObj = {
      'apptId': this.state.apptid,
      'encounterId': this.state.encid,
    };
    this.props.getPatientSingleEncounters(searchObj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEncounter && this.props.singleEncounter !== nextProps.singleEncounter) {
      let appointmentData = nextProps.singleEncounter.patientAppointment;
      if (appointmentData) {
        let staffNames = [];
        appointmentData.appointmentSingleStaff.forEach((staff) => {
          staffNames.push(staff.staffName);
        });

        let renderingProviderNames = [];
        appointmentData.appointmentRenderingProviders.forEach((staff) => {
          renderingProviderNames.push(staff.renderingProviderName);
        });

        this.setState({
          patientId: appointmentData.patientID,
          appointmentTypeName: appointmentData.appointmentTypeName,
          appointmentDate: showFormatedDate(appointmentData.startDateTime),
          appointmentTime: showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime),
          staffName: staffNames && staffNames ? staffNames.join(',') : '',
          renderingProviderName: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
          serviceFacility: appointmentData.serviceFacility,
          isDirectService: appointmentData.isDirectService,
          PatientLocationName: appointmentData.address,
        });

        let soapObj = nextProps.singleEncounter;
        let guardianSignObj = {}, clientSignObj = {}, employeeSignObj = {}, renderingProviderSignObj = {};
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              guardianSignObj = data;
            }
            if (signObj.patientSign) {
              let data = {
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: nextProps.singleEncounter.patientName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              clientSignObj = data;
            }
            if (signObj.clinicianSign) {
              let data = {
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: staffNames && staffNames ? staffNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              employeeSignObj = data;
            }
            if (signObj.renderingProviderSign) {
              let data = {
                Bytes: signObj.renderingProviderSign,
                Date: signObj.renderingProviderSignDate,
                Name: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              renderingProviderSignObj = data;
            }
          });
        }
        this.setState({
          ClientSign: clientSignObj,
          GuardianSign: guardianSignObj,
          EmployeeSign: employeeSignObj,
          enderingProviderSign : renderingProviderSignObj,
        });
      }
    }

    if (nextProps.singleEncounter && this.props.singleEncounter !== nextProps.singleEncounter) {
      let assessment = nextProps.singleEncounter.sessionNotes_BCBASupervision_SOAR;
      
      this.setState({
        IsRBTPresent: assessment.isRBTPresent === true ? 1 : 0,      
      },()=>{this.changeIsRBTPresent(null,assessment.isRBTPresent === true ? 1 : 0)});      
    }    
  }

  renderDiagnosis() {
    if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else {
      if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length !== 0) {
        return this.props.initialValues.diagnosisArray.map((diagnosis, index) => {
          if (diagnosis.IsDeleted) {
            return <tr key={index}><td colSpan='3'><span className='redfont'>{diagnosis.description}</span></td></tr>;
          }
          return (
            <tr key={index}>
              <td width="30%">{diagnosis.icdCode}</td>
              <td width="70%">{diagnosis.description ? diagnosis.description : ''}</td>
              {/* <td width="10%"><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont">Remove</button></td>*/}
            </tr>
          );
        });
      }
    }
  }


  renderCpt() {
    if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length !== 0) {
      return this.props.initialValues.CPTTableData.map((cpt, index) => {
        if (cpt.IsDeleted) {
          return <tr key={index}><td colSpan='3'><span className='redfont'>{cpt.serviceCode}</span></td></tr>;
        }
        return (
          <tr key={index}>
            <td width="20%">{cpt.serviceCode ? cpt.serviceCode : '-'}</td>
            <td width="30%">{cpt.attachedModifiers ? cpt.attachedModifiers : '-'}</td>
            <td width="50%">{cpt.description ? cpt.description : '-'}</td>
          </tr>
        );
      });
    }
  }

  handleBackClick = () => {
    let encPatientId = this.state.patientId ? base64Encode(`${this.state.patientId}`) : null;
    if (this.props.location.state && this.props.location.state.isRedirectFromPatientEncounter && encPatientId) {
      history.push(`/client/encounter/${encPatientId}`);
    } else {
      history.push('/dashboard');
    }
  };

  changeIsRBTPresent = (e, value) => {    
    this.setState({ IsRBTPresent: parseInt(value || 0, 10)});
  };
    

  renderChallengingBXTemplate = ({ fields }) => {
      return (
      <div>
        {fields.map((challengingBXModel, i) =>
          <div id="currentDiv" className="row" key={i}>
            <div className="col-sm-3">
              <Field
                name={`challengingBXModel[${i}].behavior`}
                type="text"
                maxLength="50"
                label="Behavior"
                disabled={true}
                component={renderTextField}
              />
            </div>
            <div className="col-sm-3">
              <Field
                name={`challengingBXModel[${i}].currentProgress`}
                type="text"
                maxLength="50"
                label="Current Progress"
                disabled={true}
                component={renderTextField}
              />
            </div>
            <div className="col-sm-3 pdl-40">
              <Field
                name={`challengingBXModel[${i}].information`}
                type="text"
                maxLength="150"
                label="Information"
                disabled={true}
                component={renderTextField}                
              />             

            </div>
          </div>
        )
        }
      </div>
    );
  };



  rendersSkillAcquisitionTemplate = ({ fields }) => {

    return (
      <div>
        {fields.map((skillAcquisitionModel, i) =>
          <div id="currentDiv" className="row" key={i}>
            <div className="col-sm-3">
              <Field
                name={`skillAcquisitionModel[${i}].goal`}
                type="text"
                maxLength="50"
                label="Goal"
                disabled={true}
                component={renderTextField}
              />
            </div>
            <div className="col-sm-3">
              <Field
                name={`skillAcquisitionModel[${i}].currentProgress`}
                type="text"
                maxLength="50"
                label="Current Progress"
                disabled={true}
                component={renderTextField}
              />
            </div>
            <div className="col-sm-3 pdl-40">
              <Field
                name={`skillAcquisitionModel[${i}].recommendations`}
                type="text"
                maxLength="150"
                label="Recommendations"
                disabled={true}
                component={renderTextField}                
              />             

            </div>
          </div>
        )
        }
      </div>
    );
  };


  render() {
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });

    let totalUnitsConsumed = (this.props.singleEncounter && this.props.singleEncounter.unitsConsumed) || 0;

    return (
      <div>
        {/* <h2 className="page_title">Client Encounter</h2>
        <PatientInfo patientId={this.state.patientid} />
        <div className="clearfix"></div> */}
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <CommonButton label="Back" primary={true} onTouchTap={this.handleBackClick} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    disabled={true}
                    fullWidth={true}
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceEndTime}
                    onDateChange={this.onDateChange}
                    disabled={true}
                    fullWidth={true}
                  />
                </div>
              </div>
              
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                  <h3>BCBA Supervision Note</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-6 mt-35'>
                  <div className="panel_title no_margin mb-20 require">
                    <h5>RBT Present :</h5>
                  </div>
                  <Field name="IsRBTPresent"
                    options={[{ id: 1, value: 'Yes' }, { id: 0, value: 'No' }]}
                    selectedValue={this.state.IsRBTPresent}
                    onChange={this.changeIsRBTPresent}
                    disabled={true}
                    component={renderCustomRadioButtons} />
                </div>
                {this.state.IsRBTPresent ? 
                  <div className='col-sm-6 require mt-35'>
                    <Field
                      name="RBTNameAndCredentials"
                      type="text"
                      fullWidth={true}
                      label="RBT Name And Credentials"                  
                      disabled={true}
                      component={renderTextField}                   
                    />
                  </div>
                : null}
              </div>

              <div className ="row">   
                <div className='col-sm-6'>
                  <Field
                    name="OtherPresentDuringSession"
                    type="text"
                    fullWidth={true}
                    label="Other Present During Session"                  
                    disabled={true}
                    component={renderTextField}                   
                  />   
                </div>     
                <div className='col-sm-6'>
                  <Field
                    name="ClientUpdates"
                    type="text"
                    fullWidth={true}
                    label="Client updates (i.e. medication changes, info pertaining to sleep, etc.)"                  
                    disabled={true}
                    component={renderTextField}                   
                  />   
                </div>    
              </div>

              <div className="row">
                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin mb-20 require">
                    <h5>Challenging Bx :</h5>
                  </div>
                  <FieldArray name="challengingBXModel" component={this.renderChallengingBXTemplate} />
                </div>

                <div className='col-sm-12'>
                  <Field
                    name="BIPNotes"
                    type="text"
                    fullWidth={true}
                    label="Notes regarding BIP implementation and BIP updates"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}                    
                  />
                </div>

                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin mb-20 require">
                    <h5>Skill Acquisition :</h5>
                  </div>
                  <FieldArray name="skillAcquisitionModel" component={this.rendersSkillAcquisitionTemplate} />
                </div>

                <div className='col-sm-12'>
                  <Field
                    name="OtherProgramUpdates"
                    type="text"
                    fullWidth={true}
                    label="Other Program Updates"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}                   
                  />
                </div>
                <div className='col-sm-12'>
                  <Field
                    name="CaregiverCommunicationNotes"
                    type="text"
                    fullWidth={true}
                    label="Caregiver Communication Notes"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}                   
                  />
                </div>                
                <div className='col-sm-12'>
                  <Field
                    name="ProgressTowardsDischarge"
                    type="text"
                    fullWidth={true}
                    label="Progress Towards Discharge"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                  />
                </div>
              </div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Diagnosis</h3>
                    <i className="flaticon flaticon-gym"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                      <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderDiagnosis()}
                  </TableBody>
                </Table>
              </div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Service Codes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="20%">Service Code</TableHeaderColumn>
                      <TableHeaderColumn width="30%">Modifiers</TableHeaderColumn>
                      <TableHeaderColumn width="50%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderCpt()}
                  </TableBody>
                </Table>
              </div>
              { this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes || this.state.RenderingProviderSign.Bytes ?
                <div className="row">
                  <div className="col-12">
                    <div className="panel_title mt-24  mb-20">
                      <h3>Signature</h3>
                      <i className="flaticon flaticon-medical-1"></i>
                    </div>
                  </div>
                  {
                    this.state.EmployeeSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageEmployee">

                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                                <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                  {this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                  }
                  {this.state.RenderingProviderSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.RenderingProviderSign.Bytes}`} alt={''} />
                              <h3>{this.state.RenderingProviderSign.Name} <span>(Supervising Clinician)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.RenderingProviderSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.RenderingProviderSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.RenderingProviderSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                </div>
                : ''}
            </form>
          </div>
        </div>
      </div>
    );
  }
}
EncounterForm = reduxForm({
  form: 'EncounterForm',
  enableReinitialize: true,
})(EncounterForm);
function mapStateToProps(state) {
  //let initialData = {};
  let initialData = {
    challengingBXModel: [{}],
    skillAcquisitionModel: [{}]
  };  
  let appointmentTime = null;
  if (state.patient.singleEncounter && state.patient.singleEncounter) {
   
    if (state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR) {   

      let challengingBXModel = []; 
      if (state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.bcbaSupervision_Challenging_SOAR && state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.bcbaSupervision_Challenging_SOAR.length) {
        state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.bcbaSupervision_Challenging_SOAR.filter((data, i) => {
          challengingBXModel.push({            
            'id': data.id,
            'sessionNoteId': data.sessionNoteId,
            'behavior': data.behavior,
            'currentProgress': data.currentProgress,
            'information': data.information
          });
          return challengingBXModel;
        });
      } else {
        challengingBXModel = [{}];
      }

      let skillAcquisitionModel = []; 
      if (state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.bcbaSupervision_SkillAcquisition_SOAR && state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.bcbaSupervision_SkillAcquisition_SOAR.length) {
        state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.bcbaSupervision_SkillAcquisition_SOAR.filter((data, i) => {
          skillAcquisitionModel.push({            
            'id': data.id,
            'sessionNoteId': data.sessionNoteId,
            'goal': data.goal,
            'currentProgress': data.currentProgress,
            'recommendations': data.recommendations
          });
          return skillAcquisitionModel;
        });
      } else {
        skillAcquisitionModel = [{}];
      }

      initialData['challengingBXModel'] =  challengingBXModel,
      initialData['skillAcquisitionModel'] =  skillAcquisitionModel,

      initialData['IsRBTPresent'] = state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.isRBTPresent === true ? 1 : 0,

      initialData['RBTNameAndCredentials'] = state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.rbtNameAndCredentials,
      initialData['OtherPresentDuringSession'] = state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.otherPresentDuringSession,
      initialData['ClientUpdates'] = state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.clientUpdates,
      initialData['BIPNotes'] = state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.bipNotes,
      initialData['OtherProgramUpdates'] = state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.otherProgramUpdates,
      initialData['CaregiverCommunicationNotes'] = state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.caregiverCommunicationNotes,
      initialData['ProgressTowardsDischarge'] = state.patient.singleEncounter.sessionNotes_BCBASupervision_SOAR.progressTowardsDischarge
    }

    if (state.patient.singleEncounter.patientEncounterDiagnosisCodes) {
      initialData['diagnosisArray'] = state.patient.singleEncounter.patientEncounterDiagnosisCodes;
    }
    if (state.patient.singleEncounter.patientEncounterServiceCodes) {
      initialData['CPTTableData'] = state.patient.singleEncounter.patientEncounterServiceCodes;
    }

    // if(state.patient.singleEncounter.appointmentStartDateTime){
    //   let startTimehours = state.patient.singleEncounter.appointmentStartDateTime.substr(11, 2);
    //   let endTimehours = state.patient.singleEncounter.appointmentEndDateTime.substr(11, 2);
    //   let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ?
    //     (parseInt(startTimehours, 10) - 12 < 10 ?
    //       `0${parseInt(startTimehours, 10) - 12}`
    //       : startTimehours)
    //     : startTimehours;
    //   let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;
    //   let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
    //   let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
    //   appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.appointmentStartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.appointmentEndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
    //   initialData['appointmentTime'] = appointmentTime;
    // }

    // console.log('state.patient.singleEncounter.............', state.patient.singleEncounter);

    if (state.patient.singleEncounter.startDateTime) {
      let startTimehours = state.patient.singleEncounter.startDateTime.substr(11, 2);
      let endTimehours = state.patient.singleEncounter.endDateTime.substr(11, 2);
      let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ? (parseInt(startTimehours, 10) - 12 < 10 ? `0${parseInt(startTimehours, 10) - 12}` : startTimehours) : startTimehours;
      let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;

      let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
      let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
      appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.startDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.endDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      initialData['appointmentTime'] = appointmentTime;
    }


    initialData['locationName'] = state.patient.singleEncounter.locationName;
    initialData['staffName'] = state.patient.singleEncounter.staffName;
    initialData['appointmentDate'] = state.patient.singleEncounter.patientAppointment.startDateTime;
    initialData['PatientLocationName'] = state.patient.singleEncounter.PatientLocationName;
    initialData['serviceEndTime'] = moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('HH:mm:ss');
    initialData['serviceStartTime'] = moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('HH:mm:ss');

  }

  return {
    singleEncounter: state.patient.singleEncounter,
    initialValues: initialData,  
  };
}
export default connect(mapStateToProps, { getPatientSingleEncounters })(EncounterForm);



// WEBPACK FOOTER //
// ./src/modules/patients/components/Encounter/SessionNotes_Encounter_BCBASupervision_SOAR.js